var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1140_81829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.60419C13.125 9.25881 11.7266 10.599 10 10.599C8.27344 10.599 6.875 9.25881 6.875 7.60419C6.875 5.94956 8.27344 4.6094 10 4.6094C11.7266 4.6094 13.125 5.94956 13.125 7.60419ZM10 6.40627C9.30859 6.40627 8.75 6.94159 8.75 7.60419C8.75 8.26679 9.30859 8.8021 10 8.8021C10.6914 8.8021 11.25 8.26679 11.25 7.60419C11.25 6.94159 10.6914 6.40627 10 6.40627ZM17.5 7.60419C17.5 10.876 12.9297 16.7009 10.9258 19.1042C10.4453 19.6769 9.55469 19.6769 9.07422 19.1042C7.03516 16.7009 2.5 10.876 2.5 7.60419C2.5 3.63459 5.85781 0.416687 10 0.416687C14.1406 0.416687 17.5 3.63459 17.5 7.60419ZM10 2.21356C6.89453 2.21356 4.375 4.62811 4.375 7.60419C4.375 8.06838 4.55039 8.78713 4.97266 9.74546C5.38203 10.6738 5.96328 11.6996 6.63281 12.7365C7.74219 14.466 9.03125 16.1057 10 17.326C10.9688 16.1057 12.2578 14.466 13.3672 12.7365C14.0352 11.6996 14.6172 10.6738 15.0273 9.74546C15.4492 8.78713 15.625 8.06838 15.625 7.60419C15.625 4.62811 13.1055 2.21356 10 2.21356Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1140_81829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19.1667,
    fill: "white",
    transform: "translate(2.5 0.416687)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationField);
export default __webpack_public_path__ + "static/media/location-field.1c5f0ba98e2498f99e6fbc3b830f4fe2.svg";
export { ForwardRef as ReactComponent };